module.exports = __webpack_public_path__ + "static/media/halfGlobe.520bc40d.png";